import React from 'react';
import { Check } from 'lucide-react';

export const Chips = ({ options, value = [], onToggle, testid }) => (
  <div className="opt-row" data-testid={testid}>
    {options.map((o) => {
      const on = value.includes(o);
      return (
        <button type="button" key={o} className={`opt ${on ? 'on' : ''}`} onClick={() => onToggle(o)} data-testid={`${testid}-${o.toLowerCase().replace(/[^a-z0-9]+/g, '-')}`}>
          <span className="box">{on && <Check size={12} />}</span>{o}
        </button>
      );
    })}
  </div>
);

export const Radios = ({ options, value, onPick, testid }) => (
  <div className="opt-row" data-testid={testid}>
    {options.map((o) => (
      <button type="button" key={o} className={`opt ${value === o ? 'on' : ''}`} onClick={() => onPick(o)} data-testid={`${testid}-${o.toLowerCase().replace(/[^a-z0-9]+/g, '-')}`}>
        <span className="dot" />{o}
      </button>
    ))}
  </div>
);

export default Chips;
